"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSuggestedExchangeUrl = exports.deepParse = exports.addQueryToUrl = exports.inboxConnectSettingsRedirect = void 0;

var _params = require("hub-http/helpers/params");

var _url = require("hub-http/helpers/url");

var _Validation = require("./Validation");

var baseEmailSettingsUrl = function baseEmailSettingsUrl(portalId) {
  return "/crm-settings-email/" + portalId + "/email";
};

var inboxConnectSettingsRedirect = function inboxConnectSettingsRedirect(portalId, provider) {
  return baseEmailSettingsUrl(portalId) + "?inboxconnected=true&provider=" + provider;
};

exports.inboxConnectSettingsRedirect = inboxConnectSettingsRedirect;

var addQueryToUrl = function addQueryToUrl(url, queryObj) {
  var parsed = (0, _url.parseUrl)(url);
  parsed.query = (0, _params.stringify)(queryObj);
  return (0, _url.buildUrl)(parsed);
};

exports.addQueryToUrl = addQueryToUrl;

var deepParse = function deepParse(url) {
  var parsed = (0, _url.parseUrl)(url);

  if (parsed.query) {
    parsed.query = (0, _params.parse)(parsed.query);
  }

  return parsed;
};

exports.deepParse = deepParse;
var SCHEME_PREFIX = /^https?:\/\//;

var buildSuggestedExchangeUrl = function buildSuggestedExchangeUrl(baseUrl) {
  if (typeof baseUrl !== 'string' || (0, _Validation.isExchangeAddress)(baseUrl)) {
    return null;
  }

  if (baseUrl && !SCHEME_PREFIX.test(baseUrl) && (0, _Validation.isValidHost)(baseUrl)) {
    baseUrl = "https://" + baseUrl;
  }

  var parsed = (0, _url.parseUrl)(baseUrl);
  return parsed && parsed.hostname ? "https://" + parsed.hostname + "/EWS/Exchange.asmx" : null;
};

exports.buildSuggestedExchangeUrl = buildSuggestedExchangeUrl;